import React, { useEffect, useState } from 'react';
import Loader from "../../../components/Loader";
import Paginator from "../../../components/Paginator";
import StatusToggle from "../../../components/StatusToggle";
import ApiService from "../../../services/ApiService";
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';

const List = () => {

    const [isLoader, setIsLoader] = useState(false);
    const [services, setServices] = useState([]);
    const [pagination, setPagination] = useState({});
    const [apiData, setApiData] = useState({
        search: "",
        status: "",
        page: 1,
    });

    useEffect(() => {
        getServices();
    }, [apiData.page, apiData.search, apiData.status]);

    const getServices = async () => {
        try {
            setIsLoader(true);
            const response = await ApiService.request({
                method: "GET",
                url: "admin/services",
                data: apiData
            });
            const data = response.data;
            if (data.status) {
                setServices(data.data);
                setPagination(data.pagination);
            } else {
                toast.error(data.message);
            }
            setIsLoader(false);
        } catch (error) {
            setIsLoader(false);
        }
    };

    const handlePageChange = (event) => {
        setApiData(prev => ({ ...prev, page: event }));
    };

    const clearFilter = () => {
        setApiData({ search: '', status: '', page: 1 });
    };

    const delData = async (id) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: 'you will not be able to revert it!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonColor: '#9E9B9B',
            cancelButtonText: 'No',
        });

        if (result.isConfirmed) {
            const response = await ApiService.request({
                method: "DELETE",
                url: `admin/services/${id}`,
            });
            const data = response.data;
            if (data.status) {
                getServices();
                toast.success(data.message);
            } else {
                toast.error(data.message);
            }
        }
    };

    const updateStatus = async (id) => {
        try {
            const response = await ApiService.request({
                method: "POST",
                url: `admin/services/status/${id}`,
            });
            const data = response.data;
            if (data.status) {
                getServices();
                toast.success(data.message);
                return true;
            }
            toast.error(data.message);
            return false;
        } catch {
            toast.error('Failed to update status');
            return false;
        }
    };

    return (
        <div className="d-flex flex-column flex-column-fluid">
            <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
                <div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
                    <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                        <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Services</h1>
                        <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                            <li className="breadcrumb-item text-muted">
                                <Link to="/admin/dashboard" className="text-muted text-hover-primary">Home</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <span className="bullet bg-gray-400 w-5px h-2px"></span>
                            </li>
                            <li className="breadcrumb-item text-muted">Services</li>
                        </ul>
                    </div>
                    <div className="d-flex align-items-center gap-2 gap-lg-3">
                        <Link to={`/admin/services/create/`} className="btn btn-sm btn-base">
                            Add New
                        </Link>
                    </div>
                </div>
            </div>
            <div id="kt_app_content" className="app-content flex-column-fluid">
                <div id="kt_app_content_container" className="app-container container-xxl">
                    <div className="card">
                        <div className="card-header border-0 pt-6">
                            <div className="w-100">
                                <form method="get">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="d-flex align-items-center position-relative my-1">
                                                <input
                                                    type="text"
                                                    value={apiData.search}
                                                    onChange={e => setApiData({ ...apiData, search: e.target.value, page: 1 })}
                                                    className="form-control form-control-solid me-5"
                                                    placeholder="Search service name.."
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <select
                                                className="form-select form-select-solid my-1"
                                                value={apiData.status}
                                                onChange={e => setApiData({ ...apiData, status: e.target.value, page: 1 })}
                                            >
                                                <option value="">All Statuses</option>
                                                <option value="active">Active</option>
                                                <option value="inactive">Inactive</option>
                                            </select>
                                        </div>
                                        <div className="col-md-3 mt-2">
                                            <button
                                                type="button"
                                                onClick={clearFilter}
                                                className={`btn btn-sm btn-secondary mx-1 ${!apiData.search && !apiData.status ? 'd-none' : ''}`}
                                            >
                                                clear
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="card-body pt-0">
                            <div className="dataTables_wrapper dt-bootstrap4 no-footer">
                                <div className="table-responsive">
                                    <table className="table align-middle table-hover fs-6 gy-5 dataTable no-footer">
                                        <thead>
                                            <tr className="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                                                <th>Image</th>
                                                <th>Title</th>
                                                <th>Type</th>
                                                <th>Durations</th>
                                                <th>Status</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody className="fw-semibold text-gray-600 fs-6">
                                            {services.length > 0 ? services.map((service) => (
                                                <tr key={service._id}>
                                                    <td><img src={service.image} alt="service" className='w-50px h-50px rounded' /></td>
                                                    <td>{service.title}</td>
                                                    <td>
                                                        <span className={`badge ${service.is_icebox_service ? 'badge-light-info' : 'badge-light-secondary text-dark'}`}>
                                                            {service.is_icebox_service ? 'Icebox' : 'Standard'}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        {(service.duration_options || []).length > 0 ? (
                                                            (service.duration_options || []).map((opt, i) => (
                                                                <span key={i} className="badge badge-light-primary me-1">
                                                                    {opt.duration} min
                                                                </span>
                                                            ))
                                                        ) : (
                                                            <span className="text-muted">None</span>
                                                        )}
                                                    </td>
                                                    <td>
                                                        <StatusToggle
                                                            checked={service.status}
                                                            onToggle={() => updateStatus(service._id)}
                                                        />
                                                    </td>
                                                    <td className="mt-2">
                                                        <Link to={`/admin/services/create/${service._id}`} className="btn btn-sm h-35px btn-light-primary">
                                                            <i className="bi bi-pencil-fill fs-6"></i>
                                                        </Link>
                                                        <button onClick={() => delData(service._id)} className="btn btn-sm h-35px btn-light-danger ms-2">
                                                            <i className="bi bi-trash-fill fs-6"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            )) : (
                                                <tr>
                                                    <td colSpan="6" className="text-dark text-center mt-2">No data found!!</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                    {isLoader && (
                                        <Loader text="Loading" size="30" className="text-center" />
                                    )}

                                    {pagination.total_pages > 1 && (
                                        <Paginator
                                            page={pagination.current_page}
                                            rows={pagination.per_page}
                                            totalRecords={pagination.total_records}
                                            onPageChange={handlePageChange}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default List;
